import { render, staticRenderFns } from "./ListAllProovers.vue?vue&type=template&id=22dd53e5&lang=pug&"
import script from "./ListAllProovers.vue?vue&type=script&lang=ts&"
export * from "./ListAllProovers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports